import { createEstablishment } from '@gozoki/api'
import { useMutation } from '@tanstack/react-query'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import {
  EstablishmentForm,
  type EstablishmentFormValues,
} from '~/components/routes/sellers/EstablishmentForm'
import { getAxiosErrorMessage } from '~/lib/utils'
import type { PermissionTuple } from '~/utils/ability'
import { usePermissionGuard, withRoutePermissions } from '~/utils/rbac'

const ADD_ESTABLISHMENT: PermissionTuple = ['add', 'sellers.establishments.establishment']

export const Route = createFileRoute('/_authenticated/sellers/establishment/new')({
  staticData: {
    permission: ADD_ESTABLISHMENT,
  },
  component: AddEstablishmentPage,
})
withRoutePermissions(Route)

const EMPTY_ESTABLISHMENT: EstablishmentFormValues = {
  reference: '',
  label: '',
  address: '',
  addressAdditionnal: '',
  postalCode: '',
  city: '',
  sellerId: null,
}

function AddEstablishmentPage() {
  const navigate = useNavigate()
  const canAdd = usePermissionGuard(ADD_ESTABLISHMENT).authorized

  const { mutateAsync: create } = useMutation({ mutationFn: createEstablishment })

  const navigateBack = () => navigate({ to: '/sellers/establishments' })

  return (
    <EstablishmentForm
      title="Ajouter un établissement"
      submitLabel="Ajouter"
      canEdit={canAdd}
      defaultValues={EMPTY_ESTABLISHMENT}
      onCancel={navigateBack}
      onSubmit={async (values) => {
        try {
          await create(values)
          navigateBack()
        } catch (error) {
          toast.error(getAxiosErrorMessage(error))
        }
      }}
    />
  )
}
